import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  token: null,
  region: null,
  switchRegion:true
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setToken(state, action) {
      state.token = action.payload; // Store token
    },
    setUser(state, action) {
      state.user = action.payload; // Store user data
    },
    setRegion(state, action) {
      state.region = action.payload; // Store token
    },
    setSwitchRegion(state, action) {
      state.switchRegion = action.payload; // Store token
    },
    logout(state) {
      state.user = null;
      state.token = null; // Clear token and user data
      state.region = null;
    },
  },
});

export const { setToken, setUser, setRegion, setCurrency, setSwitchRegion, logout } = authSlice.actions;
export default authSlice.reducer;
